import React from 'react';
import PropTypes from 'prop-types';
import IframedPage from '../../components/IframedPage';
import { uiVersion, getAppVersion } from '../../utils/mobile';
import Screen from '../../components/Screen';
import { localize } from '../../i18n';

const About = props => (
  <Screen title={props.t('About')}>
    <IframedPage
      wrapperClassName="about-wrapper"
      header="GEMS Access"
      subHeader={`GEMS UI ${uiVersion} ${getAppVersion()}`}
      src="https://static.keyprprod.com/mobilegems/eula.html"
    />
  </Screen>
);

About.propTypes = {
  t: PropTypes.func.isRequired,
};

export default localize(About);



// WEBPACK FOOTER //
// ./src/views/about/About.js